import React, { useState } from 'react';
import * as Styles from "./login.css"
import { useForm } from "react-hook-form";
import postData from "../../../utils/apiRequests";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'


const LoginSect = (props) => {
    const { register, errors, handleSubmit, reset } = useForm();
    const [isLoading, setLoading] = useState(false);
    const [showResponse, setResponse] = useState(false);
    const [message, setMessage] = useState('')
    const onSubmit = data => {
        setResponse(false)
        setLoading(true)
        let params = {
            email: data.email,
            password: data.password
        }
        postData('https://staging.odio.com.ng/v1/login', params)
            .then(data => {
                console.log(data); // JSON data parsed by `data.json()` call
                if (data.message === 'Created') {
                    setMessage(<Styles.SuccessSpan>Success</Styles.SuccessSpan>)
                    setResponse(true)
                    reset()
                } else {
                setMessage(<Styles.ErrorSpan>Error: {data.message}</Styles.ErrorSpan>)
                    setResponse(true)
                }
                setLoading(false)
            });
    };
    return (
        <Styles.loginWrapper>
            <div className="container">
                <Styles.LoginGrid>
                    <div className="column is-three-fifths is-full-mobile" style={{ margin: 'auto' }}>
                        <div className="column is-one-quarter is-half-mobile" style={{ paddingBottom: '0', paddingLeft: '0', paddingRight: '0' }}>
                            <Styles.LoginHeader>Customer</Styles.LoginHeader>
                        </div>
                        <Styles.LoginCard>
                            <Styles.FormContainer>
                                <Styles.FormGroup>
                                    <Styles.LoginSub>
                                        Lorem Ipsium
                            </Styles.LoginSub>
                                </Styles.FormGroup>
                                {showResponse && <Styles.FormGroup>
                                    {message}
                                </Styles.FormGroup>}
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <Styles.FormGroup>
                                        Email
                                <Styles.StyledInput type="email" name="email" ref={register({ required: true, pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ })} />
                                        {errors.email?.type === "required" && <Styles.ErrorSpan>Email is Required</Styles.ErrorSpan>}
                                        {errors.email?.type === "pattern" && <Styles.ErrorSpan>Please input a valid email address</Styles.ErrorSpan>}
                                    </Styles.FormGroup>
                                    <Styles.FormGroup>
                                        Password
                                <Styles.StyledInput type="password" name="password" ref={register({ required: true })} />
                                        {errors.email?.type === "required" && <Styles.ErrorSpan>Email is Required</Styles.ErrorSpan>}
                                        {errors.password && <Styles.ErrorSpan>Password is Required</Styles.ErrorSpan>}
                                    </Styles.FormGroup>
                                    <Styles.FormGroup>
                                        <Styles.SubmutButton>
                                            Log In
                                            &nbsp;
                                        {isLoading && <FontAwesomeIcon icon={faCircleNotch} spin />}
                                        </Styles.SubmutButton>
                                    </Styles.FormGroup>
                                </form>
                            </Styles.FormContainer>
                        </Styles.LoginCard>
                    </div>
                </Styles.LoginGrid>
            </div>
        </Styles.loginWrapper>
    );
}
export default LoginSect;